"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urls = void 0;
const apiVersion = "/api/v1/";
exports.urls = {
    workspace: `${apiVersion}discovery/workspace`,
    deviceToken: `${apiVersion}discovery/deviceToken`,
    clearDeviceToken: `${apiVersion}discovery/logout`,
    syncChatList: `${apiVersion}user/sync/chats`,
    chatList: `${apiVersion}user/chats`,
    groupInfo: (id) => `${apiVersion}user/group/${id}`,
    userProfile: (id) => `${apiVersion}user/${id}?type=PROFILE`,
    directoryData: `${apiVersion}user/sync/directory-data`,
    appData: `${apiVersion}user/apps-directory`,
    syncChat: (id) => `${apiVersion}user/sync/chats/${id}`,
    chat: (id) => `${apiVersion}user/chats/${id}`,
    group: `${apiVersion}user/group`,
    onboardPatients: `${apiVersion}onboard/patients`,
    adminUser: `${apiVersion}admins/user`,
    designation: `${apiVersion}user/sync/designation`,
    member: `${apiVersion}user/group/member`,
    signedUrl: `${apiVersion}user/event/s3`,
    exportChat: `${apiVersion}user/chats/exports`,
    initiateExportChat: `${apiVersion}user/chats/chatPdf`,
    initiateMediaChat: `${apiVersion}user/chats/mediazip`,
    alert: `${apiVersion}user/alerts/ALL`,
    acknowledgement: `${apiVersion}user/alerts/ACKNOWLEDGEMENT`,
    sentAcknowledgement: `${apiVersion}user/alerts/SENT_ACKNOWLEDGEMENT`,
    priority: `${apiVersion}user/alerts/PRIORITY`,
    nonPatientChat: `${apiVersion}user/group/non-patient`,
    groupEmail: `${apiVersion}user/group/email`,
    department: `${apiVersion}user/sync/department`,
    referrals: `${apiVersion}user/alert/referral`,
    ackRecipientList: (id) => `${apiVersion}user/message/${id}/info`,
    referralSource: `${apiVersion}user/referral-source`,
    communityLiaisoning: `${apiVersion}user/community-liaisoning`,
    broadcastInfo: (id) => `${apiVersion}user/broadcast/${id}`,
    revokeReferral: `${apiVersion}user/group/revoke-referral`,
    broadcast: `${apiVersion}user/broadcast`,
    broadcastMember: `${apiVersion}user/broadcast/member`,
    groupSettings: `${apiVersion}user/group/setting`,
    userSettings: `${apiVersion}user/settings`,
    userProfileUpdate: `${apiVersion}user/`,
    starMessage: `${apiVersion}user/message/star-mark`,
    advanceSearch: `${apiVersion}user/group/advanceSearch`,
    workload: `${apiVersion}user/workload`,
    recentContacts: `${apiVersion}user/recentContacts`,
    scheduleVisit: `${apiVersion}user/schedules`,
    templates: (id, selectedRole) => `${apiVersion}user/group/${id}/template${selectedRole ? `?discipline=${selectedRole}` : ""}`,
    rpmReading: `${apiVersion}user/group/rpm-reading`,
    managePatientDevice: `/rpm/agency/device-patient`,
    exportRequest: `${apiVersion}user/chats/export-request`,
    leaveAndDeleteGroup: `${apiVersion}user/group/leave`,
    organizationMedia: `${apiVersion}user/media`,
    assignedPatients: (id) => `${apiVersion}user/${id}?type=ASSIGNED_PATIENTS`,
    userMedia: (id) => `${apiVersion}user/${id}?type=MEDIA`,
    broadcastDeleteMember: `${apiVersion}user/broadcast/delete-member`,
    quickReplies: `${apiVersion}user/settings/quickReplies`,
    newEpisode: `${apiVersion}user/group/new-episode`,
    fetchPreSignedMedia: `${apiVersion}miscellaneous/pre-signed-put-url-for-media`,
    fetchPreSignedThumbnail: `${apiVersion}miscellaneous/pre-signed-put-url-for-thumbnail`,
    getLabs: `${apiVersion}labs`,
    getLabDetails: (labId) => `${apiVersion}labs/${labId}`,
    getLabRequisitions: (groupId) => `${apiVersion}labs/requisitions/patient-group/${groupId}`,
    getAllLabRequisitions: `${apiVersion}labs/requisitions`,
    getLabRequisitionOrders: (requisitionId) => `${apiVersion}labs/orders?requisitionId=${requisitionId}`,
    requestLab: `${apiVersion}labs/requisitions`,
    getPatientInformation: (mrn) => `${mrn}/patientDetails`,
    getInsuranceInformation: (mrn) => `${mrn}/insurance`,
    getPhysicianInformation: (mrn) => `${mrn}/physician`,
    getDiagnosisInformation: (mrn) => `${mrn}/diagnosis`,
    getRecentMRNs: (limit) => `?limit=${limit}`,
    getRecentMRNsQa: (limit) => `qa?limit=${limit}`,
    syncQueue: `${apiVersion}sync-queue`,
    adminSettings: `${apiVersion}admins/settings`,
    approveSyncQueueItem: (id) => `${apiVersion}sync-queue/${id}/approve`,
    rejectSyncQueueItem: (id) => `${apiVersion}sync-queue/${id}/reject`,
    // --- Auto Ack ------------------------------------------------------------
    // GET returns the current rules; PUT replaces the full rules array (there is
    // no per-rule create/update/delete).
    autoAckRules: `${apiVersion}admins/org-setting/auto-ack`,
    autoAckEvents: `${apiVersion}admins/org-setting/auto-ack/events`,
    orgGeneralSettings: `${apiVersion}admins/org-setting/general`,
};
